// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"m2-z","displaySixCardTiles":"n2-z"};